import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { STATUS } from 'projectConstants';
import apiService from 'services';

const initialState: any = {
  version: null,
};

export const fetchVersion = createAsyncThunk('version', async () => {
  const response = await apiService.version();
  return response.data;
});

const UtilsSlice = createSlice({
  initialState,
  name: 'utilsSlice',
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchVersion.fulfilled, (state, action) => {
      state.version = action.payload;
      state.modelStatus = STATUS.SUCCESS;
    });
  },
});

export default UtilsSlice.reducer;

export const getVersion = (state: any) => {
  return state.utilsSlice?.version;
};
